import React from "react";
import { motion } from "framer-motion";
import { Ban, PieChart, Building2, Zap } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const benefits = [
  {
    icon: Ban,
    title: "Zero Upfront Costs",
    description:
      "No listing fees, no marketing costs, no commissions out of pocket. We invest in selling your land — you keep your share.",
  },
  {
    icon: PieChart,
    title: "Transparent Profit Split",
    description:
      "Every joint venture agreement spells out exactly how proceeds are divided before you sign — no surprises at closing.",
  },
  {
    icon: Building2,
    title: "Local Market Expertise",
    description:
      "Our team knows Texas land values, buyers, and financing options, so your property is priced and marketed to sell.",
  },
  {
    icon: Zap,
    title: "Fast, Flexible Closings",
    description:
      "Skip months of showings and price drops. Most joint venture properties close within weeks of finding the right buyer.",
  },
];

const JVWhyPartner = () => (
  <section className="bg-[#F5F3EF] py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="mb-10 text-center sm:mb-14">
        <p className="text-xs font-semibold uppercase tracking-wide text-[#C1694F] sm:text-sm">
          Why Partner With Us
        </p>
        <h2 className="mt-2 text-2xl font-bold text-[#16213E] sm:text-4xl">
          Built For Landowners, Not Just Listings
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {benefits.map((benefit) => (
          <motion.div
            key={benefit.title}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeUp}
            className="rounded-2xl bg-white p-6 text-center shadow-sm ring-1 ring-black/5 transition-shadow hover:shadow-md sm:p-7"
          >
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#C1694F]/10">
              <benefit.icon className="h-6 w-6 text-[#C1694F]" strokeWidth={1.75} />
            </div>
            <h3 className="mb-2 text-base font-semibold text-[#16213E]">{benefit.title}</h3>
            <p className="text-sm leading-relaxed text-slate-600">{benefit.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default JVWhyPartner;
